"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var draft_js_1 = require("draft-js");
var draft_js_export_html_1 = require("draft-js-export-html");
var html_react_parser_1 = __importStar(require("html-react-parser"));
var react_1 = __importDefault(require("react"));
var constants_1 = require("../constants");
var is_valid_json_1 = __importDefault(require("./is-valid-json"));
// tslint:disable-next-line: no-var-requires
var entities = require("entities");
function ReactHtmlParser(html, config) {
    var options = {
        replace: function (_a) {
            var attribs = _a.attribs, children = _a.children, tagName = _a.name;
            if (tagName === constants_1.FIGURE_TAG) {
                return react_1["default"].createElement(react_1["default"].Fragment, null, html_react_parser_1.domToReact(children, options));
            }
            if (tagName === constants_1.P_TAG) {
                if (children && children.length === 1) {
                    var child = children[0];
                    var name_1 = child.name;
                    if (name_1 === constants_1.BR_TAG) {
                        return react_1["default"].createElement("br", null);
                    }
                }
            }
            if (tagName === constants_1.ANCHOR_TAG) {
                var LinkWrapper = config.LinkWrapper, useTargetBlank = config.useTargetBlank;
                var target = useTargetBlank ? constants_1.TARGET_BLANK : attribs.target;
                return LinkWrapper ? (react_1["default"].createElement(LinkWrapper, __assign({}, attribs, { target: target }), html_react_parser_1.domToReact(children, options))) : (react_1["default"].createElement("a", __assign({}, attribs, { target: target }), html_react_parser_1.domToReact(children, options)));
            }
            if (tagName === constants_1.INPUT_TAG &&
                attribs.type !== constants_1.SUBMIT &&
                attribs.value === "") {
                return react_1["default"].createElement("input", __assign({}, attribs, { value: null }));
            }
            return null;
        }
    };
    return html_react_parser_1["default"](html, options);
}
function convertEntityToHTML(content, config) {
    var HTML = entities.decodeHTML(draft_js_export_html_1.stateToHTML(draft_js_1.EditorState.createWithContent(draft_js_1.convertFromRaw(content)).getCurrentContent()));
    HTML = HTML.replace(new RegExp(constants_1.HORIZONTAL_RULE, "g"), constants_1.HR_TAG);
    return ReactHtmlParser(HTML, config);
}
function parseTextBlock(config) {
    var editor = config.editor;
    var content = is_valid_json_1["default"](editor);
    return !content ? [] : convertEntityToHTML(content, config);
}
exports["default"] = parseTextBlock;
